import { Outlet, createFileRoute } from "@tanstack/react-router";

import UnauthorizedPage from "@/components/pages/UnauthorizedPage";
import useIsMyDiary from "@/features/patients/hooks/useIsMyDiary";

const EntryPage = () => {
	const { diaryId } = Route.useParams();
	const { isMyDiary } = useIsMyDiary(diaryId);

	return (
		<>
			{isMyDiary ? (
				<UnauthorizedPage message="As this is not your diary you cannot add entries." />
			) : (
				<div className="md-width">
					<Outlet />
				</div>
			)}
		</>
	);
};

export const Route = createFileRoute(
	"/_app/diaries/$diaryId/observation/$observationId/entry/$entry",
)({
	component: EntryPage,
});
